export default __webpack_public_path__ + "static/media/Thug's Bracers of Charred Earth.7acb3d0f.jpg";